import React from 'react';
import { useLocation } from 'react-router-dom';
import VisualizarFichaInscricaoDividaAtiva from './components/VisualizarFichaInscricaoDividaAtiva';

export default function FichaInscricaoDividaAtiva() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const hash = query.get('hash');

    return (
        <VisualizarFichaInscricaoDividaAtiva hash={hash} />
    );
}
